import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";
import useSEO from "../hooks/useSEO";

export default function MerciContact() {
  useSEO({
    title: "Merci — Demande bien reçue",
    description:
      "Votre demande a bien été reçue. L'équipe YONO revient vers vous sous 48 heures pour échanger sur votre projet.",
    path: "/contact/merci",
  });

  useEffect(() => {
    // Empêcher l'indexation Google de la page de remerciement
    let robots = document.querySelector('meta[name="robots"]');
    let created = false;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
      created = true;
    }
    const previous = robots.getAttribute("content");
    robots.setAttribute("content", "noindex, nofollow");

    // Google Ads — conversion "Demande de devis"
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "ads_conversion_Demande_de_devis_1", {});
    }

    return () => {
      if (created) {
        robots.remove();
      } else if (previous !== null) {
        robots.setAttribute("content", previous);
      }
    };
  }, []);

  return (
    <div data-testid="merci-page">
      <section className="pt-32 pb-24">
        <div className="container-yono max-w-3xl">
          <CheckCircle
            size={56}
            strokeWidth={1.2}
            className="text-[var(--yono-wood)] mb-8"
          />
          <p className="eyebrow mb-5">Demande reçue</p>
          <h1 className="font-heading text-[28px] sm:text-[38px] lg:text-[48px] tracking-tight leading-[1.05]">
            Merci, votre demande nous est bien parvenue.
          </h1>
          <div className="mt-8 space-y-5 text-[15px] leading-[1.85] text-[var(--yono-soft-black)]/80">
            <p>
              Notre équipe a reçu votre message et l'étudie attentivement. Nous
              revenons vers vous sous{" "}
              <strong className="text-[var(--yono-soft-black)]">
                48 heures ouvrées
              </strong>{" "}
              pour échanger sur votre projet, vos contraintes d'exploitation et
              les configurations les plus adaptées.
            </p>
            <p>
              En attendant, n'hésitez pas à découvrir les autres habitats de la
              gamme ou à parcourir notre approche fabrication.
            </p>
          </div>

          <div className="mt-12 flex flex-wrap gap-3">
            <Link
              to="/gamme"
              className="btn-primary"
              data-testid="merci-cta-gamme"
            >
              Découvrir la gamme <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
            <Link
              to="/"
              className="btn-outline"
              data-testid="merci-cta-home"
            >
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
